import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { Button } from '@tcc/crate';

const baseString = 'vra-script-flow-step-footer';
const classString = classNames({
  [`${baseString}__nav__button`]: true,
  [`${baseString}__nav__button--forward`]: true
});

const ScriptFlowNextNavButton = ({
  canGoForward,
  isFinalStep,
  onClickForward,
  isExperimentScripting
}) => {
  let messageKey = 'button-text__next';
  if (isExperimentScripting && isFinalStep) {
    messageKey = 'button-text__generate';
  } else if (isFinalStep) {
    messageKey = 'button-text__next--edit-rx';
  }

  return (
    <Button
      className={classString}
      disabled={!canGoForward}
      mode='primary'
      onClick={onClickForward}
      testId={`${baseString}__button--forward`}>
      {getMessage(messageKey)}
    </Button>
  );
};
ScriptFlowNextNavButton.propTypes = {
  canGoForward: PropTypes.bool.isRequired,
  isExperimentScripting: PropTypes.bool,
  isFinalStep: PropTypes.bool.isRequired,
  onClickForward: PropTypes.func.isRequired
};
export default ScriptFlowNextNavButton;
